import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { arrayHasItems, removeLoadingKey } from '../helpers/common'

export const DDPLoadingKeys = {
    getDemandByProductGroup: "GET_DEMAND_DATA",
}

const initialState = {
    loading: false,
    demandData: {
        product: {},
        items: {},
        graph: {}
    },
    loadingKeys: [],
    firstLoadComplete: false,
    error: null,
}

export const getDemandByProductGroup = createAsyncThunk(
    'ddp/getDemandByProductGroup',
    async ({
        groupId,
        metric,
        channel,
        valueMode,
        variantByProduct,
        forecast,
        otb,
        compareYoY
    }, { rejectWithValue }) => {
        try {
            const { data } = await axios.get('/api/v1/ddp', { params: {
                groupId,
                metric,
                channel,
                valueMode,
                variantByProduct,
                forecast,
                otb,
                compareYoY
            }});
            return data;
        } catch (error) {
            if ('string' === typeof error.response.data) {
                return rejectWithValue(error.response.data)
            } else {
                return rejectWithValue(error.response.data.errors || error.response.data.error)
            }
        }
    }
)

export const ddpSlice = createSlice({
    name: 'ddp',
    initialState,
    reducers: {
        cleanUpTheSelectedDDP: (state) => {
            state.demandData = {
                product: {},
                items: {}
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDemandByProductGroup.pending, (state) => {
                state.loading = true;
                state.firstLoadComplete = false;
                state.loadingKeys = [...state.loadingKeys, DDPLoadingKeys.getDemandByProductGroup];
            })
            .addCase(getDemandByProductGroup.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.demandData = action.payload;
                state.firstLoadComplete = true;
                state.loadingKeys = removeLoadingKey(DDPLoadingKeys.getDemandByProductGroup, state.loadingKeys);
            })
            .addCase(getDemandByProductGroup.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error?.message;
                state.demandData = {
                    product: {},
                    items: {}
                };
                state.firstLoadComplete = true;
                state.loadingKeys = removeLoadingKey(DDPLoadingKeys.getDemandByProductGroup, state.loadingKeys);
            })
    }
})
export const { cleanUpTheSelectedDDP } = ddpSlice.actions;
export default ddpSlice.reducer 